document.addEventListener('click', function (e) {
    document.querySelectorAll('.cf7-multiselect').forEach(ms => {
        if (ms.contains(e.target)) {
            if (e.target.classList.contains('cf7-multiselect__trigger')) {
                ms.classList.toggle('open');
            }
        } else {
            ms.classList.remove('open');
        }
    });
});
